import styled from '@emotion/styled/macro';
import { forPhoneOnly, forTabletPortraitDown, Variables } from '@enter/core';
import { IOrdinalProps, pieChartColors } from './shared.styles';

interface IHoverProps {
    hover?: boolean;
}

type ISegment = IHoverProps & IOrdinalProps;

export const PieChart = styled.svg`
    margin: 0 auto;

    height: 360px;
    width: 360px;
    ${forTabletPortraitDown(`
        height: 320px;
        width: 320px;
    `)};
    ${forPhoneOnly(`
        height: 300px;
        width: 300px;
    `)};
`;

export const PieSegment = styled.path<ISegment>`
    fill: ${pieChartColors};
    cursor: pointer;
    stroke-width: 0.5px;

    opacity: ${({ hover }): number => (hover ? 1 : 0.9)};
    stroke: ${(props): string => (props.hover ? Variables.Colors.blackPearl : 'inherit')};
`;
export const PieLabel = styled.text<IHoverProps>`
    cursor: pointer;
    font-size: 15px;
    font-weight: ${(props): string => (props.hover ? '500' : 'normal')};
`;
export const PieName = styled.text`
    font-size: 18px;
    font-weight: 500;
    color: ${Variables.Colors.blackPearl};
`;
export const PieAmount = styled.text`
    font-size: 28px;
    color: ${Variables.Colors.blackPearl};
`;
